import type { IntegrationApplicationMap } from '@wix/members-area-integration-kit';
import type { EditorSDK } from '@wix/platform-editor-sdk';

interface AppState {
  isDeletingSinglePage: boolean;
  isClassicEditor: boolean;
  isResponsiveEditor: boolean;
  isBuilderEditor: boolean;
  isStudio2Editor: boolean;
  integratedAppsMap: IntegrationApplicationMap;
  staticsBaseUrl: string;
  blogWriterProfilesOnly?: boolean;
  isUninstalling: boolean;
  editorSDK: EditorSDK | undefined;
  isSuccessfulEditorReady: boolean;
  isMigration: boolean;
}

let applicationState: AppState = {
  isDeletingSinglePage: false,
  isClassicEditor: false,
  isResponsiveEditor: false,
  isBuilderEditor: false,
  isStudio2Editor: false,
  integratedAppsMap: {},
  staticsBaseUrl: '',
  blogWriterProfilesOnly: false,
  isUninstalling: false,
  editorSDK: undefined,
  isSuccessfulEditorReady: true,
  isMigration: false,
};

const setIsMigration = (isMigration: boolean) => {
  applicationState = {
    ...applicationState,
    isMigration,
  };
};

const setIsBlogWriterProfilesOnly = (blogWriterProfilesOnly: boolean) => {
  applicationState = {
    ...applicationState,
    blogWriterProfilesOnly,
  };
};

const setIsResponsiveEditor = (isResponsiveEditor: boolean) => {
  applicationState = {
    ...applicationState,
    isResponsiveEditor,
  };
};

const setIsBuilderEditor = (isBuilderEditor: boolean) => {
  applicationState = {
    ...applicationState,
    isBuilderEditor,
  };
};

const setIsStudio2Editor = (isStudio2Editor: boolean) => {
  applicationState = {
    ...applicationState,
    isStudio2Editor,
  };
};

const setIsClassicEditor = (isClassicEditor: boolean) => {
  applicationState = {
    ...applicationState,
    isClassicEditor,
  };
};

const setStaticsBaseUrl = (staticsBaseUrl: string) => {
  applicationState = {
    ...applicationState,
    staticsBaseUrl,
  };
};

const setIntegratedApps = (integratedAppsMap: IntegrationApplicationMap) => {
  applicationState = {
    ...applicationState,
    integratedAppsMap,
  };
};

const setIsUninstalling = (isUninstalling: boolean) => {
  applicationState = {
    ...applicationState,
    isUninstalling,
  };
};
const setEditorSDK = (editorSDK: EditorSDK) => {
  applicationState = {
    ...applicationState,
    editorSDK,
  };
};

const getEditorSDK = () => applicationState.editorSDK;
const getIsUninstalling = () => applicationState.isUninstalling;
const getIsResponsiveEditor = () => applicationState.isResponsiveEditor;
const getIsClassicEditor = () => applicationState.isClassicEditor;
const getIsBuilderEditor = () => applicationState.isBuilderEditor;
const getIsStudio2Editor = () => applicationState.isStudio2Editor;
const getStaticsBaseUrl = () => applicationState.staticsBaseUrl;
const getAllIntegratedApps = () => applicationState.integratedAppsMap || {};
const getVerticalsApps = (verticalAppDefId: string) => applicationState.integratedAppsMap[verticalAppDefId] || [];
const getIsMigration = () => applicationState.isMigration;
const getIsBlogWriterProfilesOnly = () => applicationState.blogWriterProfilesOnly;
const removeVerticalsApps = (verticalAppDefId: string) => {
  // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
  delete applicationState.integratedAppsMap[verticalAppDefId];
};
const getIsSuccessfulEditorReady = () => applicationState.isSuccessfulEditorReady;
const setIsSuccessfulEditorReady = (isSuccessful: boolean) => {
  applicationState.isSuccessfulEditorReady = isSuccessful;
};

export {
  getAllIntegratedApps,
  getEditorSDK,
  getIsBlogWriterProfilesOnly,
  getIsBuilderEditor,
  getIsClassicEditor,
  getIsMigration,
  getIsResponsiveEditor,
  getIsStudio2Editor,
  getIsSuccessfulEditorReady,
  getIsUninstalling,
  getStaticsBaseUrl,
  getVerticalsApps,
  removeVerticalsApps,
  setEditorSDK,
  setIntegratedApps,
  setIsBlogWriterProfilesOnly,
  setIsBuilderEditor,
  setIsClassicEditor,
  setIsMigration,
  setIsResponsiveEditor,
  setIsStudio2Editor,
  setIsSuccessfulEditorReady,
  setIsUninstalling,
  setStaticsBaseUrl,
};
